import React from 'react';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { Box, Button, DialogContent } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';

const CategoryGroupDialog = ({ open, onClose, data: { restaurantCategories, categories, categoriesInGroupsList }, handleToggleCategory, handleClose, handleSave }) => {
    return (
        <Dialog open={open} onClose={onClose} sx={{
            '& .MuiDialog-paper': {
                borderRadius: 3,
                xs: {
                    width: 'calc(100% - 2rem)',
                    padding: "0.5rem 2rem",
                },
                sm: {
                    width: '36rem',
                    padding: "0.5rem 2rem",
                },
            },
        }}>
            <DialogTitle id="alert-dialog-title">
                Choose Categories
            </DialogTitle>

            <DialogContent>
                <FormGroup>
                    {restaurantCategories.map(category => {
                        const isChecked = categories.find(cat => cat._id === category._id) ? true : false;
                        return <FormControlLabel
                            required
                            control={<Checkbox
                                checked={isChecked}
                                onChange={() => handleToggleCategory(category, isChecked)}
                                disabled={!isChecked && categoriesInGroupsList.has(category._id)}
                                sx={{
                                    color: "black",
                                    "&.Mui-checked": { color: "black" },
                                    ml: 0,
                                    mr: 1,
                                    padding: 0,
                                    my: 1,
                                    "& .MuiTypography-root": { fontSize: "0.875rem" },
                                }}
                            />}
                            label={category.name}
                        />
                    })}
                </FormGroup>
            </DialogContent>

            <DialogActions>
                <Button
                    sx={{
                        backgroundColor: '#000000',
                        color: '#ffffff !important',
                        borderRadius: 2,
                        minWidth: '14rem',
                        px: 2,
                        '&:hover': {
                            color: '#ffffff !important',
                            backgroundColor: '#000000 !important',
                        },
                        '&:disabled': {
                            opacity: 0.5
                        }
                    }}
                    onClick={handleClose}
                >Close</Button>
            </DialogActions>
        </Dialog>
    )
}

export default React.memo(CategoryGroupDialog);
